module.exports = __webpack_public_path__ + "media/npc_dota_hero_spectre.884cd391.webm";